// extracted by mini-css-extract-plugin
export default {"sort":"tP-z","sortSelect":"uP-z","disabled":"vP-z"};